import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {ApiDynamicArticle} from "@api/dynamic-articles";
import {DynamicArticleService} from "@iw-shop/dynamic-article/services/dynamic-article.service";

@Component({
    selector: 'iw-shop-customer-dynamic-articles',
    standalone: false,
    templateUrl: './customer-dynamic-articles.component.html',
    styleUrls: ['./customer-dynamic-articles.component.scss']
})
export class CustomerDynamicArticlesComponent implements OnInit, OnDestroy {
    @Output() onChangeCustomerDynamicArticleIds = new EventEmitter<string[]>();

    destroy$: Subject<boolean> = new Subject<boolean>();

    dynamicArticles: ApiDynamicArticle[] = [];
    customerDynamicArticleIds: string[] = [];


    constructor(private store: Store<AppState>, private dynamicArticleService: DynamicArticleService) {

    }


    ngOnInit(): void {
        this.dynamicArticleService.getByCategory('customerDynamicArticles.ngOnInit',['selectionWithOptionalMappingToCustomer'])
            .subscribe(
                {
                    next: (r) => {
                        if (r?.result) {
                            this.dynamicArticles = r.result?.dynamicArticles.data;
                        }
                    }
                }
            );
        this.store.select(getSelectedCustomer)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                r => {
                    this.customerDynamicArticleIds = r?.dynamicArticleIds ?? [];
                }
            );
    }

    toggleItem(id: string) {
        let customerDynamicArticleIds: string[] = [];
        if (this.customerDynamicArticleIds.filter(x => x == id)[0]) {
            customerDynamicArticleIds = this.customerDynamicArticleIds.filter(x => x !== id);
        } else {
            customerDynamicArticleIds.push(id);
        }
        this.customerDynamicArticleIds = customerDynamicArticleIds;
        this.onChangeCustomerDynamicArticleIds.emit(this.customerDynamicArticleIds);
    }

    isSelected(id: string) {
        return !!this.customerDynamicArticleIds.filter(x => x == id)[0];
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
